import React from 'react';
import WithProgression from '../../../bundles/common/components/Wrappers/WithProgression';

/**
 * HeroUtilitiesPhotoProgressive - Progressive hero image with responsive loading
 *
 * Combines progressive loading with native browser features:
 * - Starts with 500px image (low quality) for fast initial load
 * - Progresses to larger version (high quality) after page load
 * - Uses srcset on high-quality image for responsive optimization
 * - Leverages IntersectionObserver for lazy loading detection
 */
export default function HeroUtilitiesPhotoProgressive({ width = '100%' }) {
    // Low quality: Always start with 500px for fast initial load
    const lowQualitySrcSet = '/landing/hero-utilities-500px.png 500w';

    // High quality: Use larger version with srcset for browser optimization
    // Browser will select from 1000w, 1500w, 2000w based on viewport and DPR
    const highQualitySrcSet = '/landing/hero-utilities-1000px.png 1000w, /landing/hero-utilities-1500px.png 1500w, /landing/hero-utilities-2000px.png 2000w';

    // Sizes attribute: Hero images take full viewport width
    const sizes = '100vw';

    return (
        <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
            <WithProgression
                lowQualitySrcSet={lowQualitySrcSet}
                highQualitySrcSet={highQualitySrcSet}
                sizes={sizes}
                alt="Utilities and budgeting made easy"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                loading="lazy"
            />
        </div>
    );
}
